module.exports = __webpack_public_path__ + "static/img/banner-01.c531068.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner-01.jpg
// module id = DBTz
// module chunks = 1